module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class=\'chart\' id="chart"></div>\n';

}
return __p
}